import { z } from "zod";

const DEFAULT_PAGE_OPTIONS = {
  number: 1,
  size: 5,
};

const zSchema = z
  .object({
    number: z.number().int().positive().default(DEFAULT_PAGE_OPTIONS.number),
    size: z.number().int().positive().default(DEFAULT_PAGE_OPTIONS.size),
  })
  .default(DEFAULT_PAGE_OPTIONS);
type Schema = z.infer<typeof zSchema>;

export { DEFAULT_PAGE_OPTIONS, zSchema };
export type { Schema };
